const falsy = /^(?:f(?:alse)?|no?|0+)$/i;
export function booleanParser(val) {
	return !falsy.test(val) && !!val;
}
